let proceedButtonClickListener = () => {
    const areHelpBlocksHidden = () => {
        let $helpBlocks = $('.help-block');
        let result = true;
        $helpBlocks.each((i, element) => {
            if ($(element).css('display') === 'block') {
                result = false;
            }
        });
        return result;
    };

    let $paymentModal = $('#payment_modal');
    let $proceedToPaymentButton = $('[data-next-step="payment"]');
    if (
        $paymentModal.length !== 0
        && $proceedToPaymentButton.length !== 0
        && areHelpBlocksHidden()
    ) {
        const event = new Event('showPaymentModal');
        document.dispatchEvent(event);
        $paymentModal.modal('show');
    }
};

export default proceedButtonClickListener;
